export default "__VITE_ASSET__DepMmLXD__"